export default __webpack_public_path__ + "static/media/add.1b96cade.svg";